/* eslint-disable max-len */
import React from 'react';
function SignOff() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.71 4.04207C21.1 3.65211 21.1 3.02217 20.71 2.63221L18.37 0.292455C18.1832 0.105222 17.9295 0 17.665 0C17.4005 0 17.1468 0.105222 16.96 0.292455L15 2.25225L18.75 6.00186L20.71 4.04207ZM4 13.2511L14 3.25215L17.75 7.00176L7.75 17.0007H4V13.2511ZM6 15.0009H6.92L14.92 7.00176L14 6.08186L6 14.081V15.0009ZM24 20.0004H0V24H24V20.0004Z" })));
}
export default SignOff;
